angular
  .module("pe4h")
  .controller("AboutCtrl", function(
    $scope,
    $http,
    configuration,
    $state,
    $timeout,
    $location,
    $anchorScroll
  ) {
    $scope.contactUs = function() {
      $http({
        url: configuration.webApi.about.contact_us,
        method: "POST",
        data: {
          Name: $scope.name,
          Email: $scope.email,
          Message: $scope.message,
          Role: $scope.role
        }
      })
        .success(function(res, status, headers, config) {
          $scope.alertError(
            "Sent",
            "Thank you for your message. We'll get back to you as soon as possible."
          );
        })
        .error(function(error, status, headers, config) {
          $scope.alertErrorFromServer(error);
        });
    };
    function init() {
      $scope.canonicalUrl = configuration.pe4hUrl.substring(0,configuration.pe4hUrl.length-1) + $state.current.url;
      var location = $state.params["#"];
      if (location) {
        $location.hash(location);
        $anchorScroll();
      }
    }
    //init();
    $timeout(function() {
      init();
    }, 100);
  });
